<template>
  <v-dialog
    v-if="organization"
    v-model="dialog"
    class="org-profile-preview"
    max-width="80%"
    transition="dialog-bottom-transition"
  >
    <!-- Activator -->
    <template #activator="{on, attrs}">
      <v-btn
        class="org-profile-preview__btn mb-2 mb-md-0 mr-sm-6"
        color="info"
        button
        outlined
        large
        v-bind="attrs"
        v-on="on"
      >
        PREVISUALIZAR PERFIL
      </v-btn>
    </template>
    
    <!-- Preview toolbar -->
    <v-toolbar
      class="org-profile-preview__toolbar rounded-t-xl"
      color="#5294E2"
      elevation="0"
      absolute
      dark
    >
      <v-toolbar-title class="org-profile-preview__title">
        Perfil de "<span class="org-profile-preview__title--bold">{{ title }}</span>"
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn @click="onCloseClick" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <!-- Preview content -->
    <v-card class="org-profile-preview__content">
      <OrganizationInfo :organization="organization" />
    </v-card>
  </v-dialog>
</template>

<script>
import OrganizationInfo from "@/components/OrganizationInfo";

export default {
    name: "OrganizationProfilePreview",

    props: ["organization"],

    components: { OrganizationInfo },

    data() {
        return {
            dialog: false,
            goalsObj: [
                { tooltip: "Fin a la Pobreza", img: "goal-01" },
                { tooltip: "Hambre cero", img: "goal-02" },
                { tooltip: "Salud y bienestar", img: "goal-03" },
                { tooltip: "Educación de calidad", img: "goal-04" },
                { tooltip: "Igualdad de género", img: "goal-05" },
                { tooltip: "Agua limpia y saneamiento", img: "goal-06" },
                { tooltip: "Energía asequible y no contaminante", img: "goal-07" },
                { tooltip: "Trabajo decente y crecimiento económico", img: "goal-08" },
                { tooltip: "Industria, innovación e infraestructura", img: "goal-09" },
                { tooltip: "Reducción de las desigualdades", img: "goal-10" },
                { tooltip: "Ciudades y comunidades sostenibles", img: "goal-11" },
                { tooltip: "Producción y consumo responsables", img: "goal-12" },
                { tooltip: "Acción por el clima", img: "goal-13" },
                { tooltip: "Vida submarina", img: "goal-14" },
                { tooltip: "Vida de ecosistemas terrestres", img: "goal-15" },
                { tooltip: "Paz, justicia e instituciones sólidas", img: "goal-16" },
                { tooltip: "Alianzas para lograr objetivos", img: "goal-17" }
            ],
            goalsToShow: [],
            locations: "",
        };
    },

    created() {
        this.locations = location.pathname;
        this.goalsToShow = this.organization.goals.slice(0, 4);
    },

    computed: {
        getCity() {
            const city = this.organization.city;
            return city ? city.substring(0, city.indexOf("(") - 1) : "";
        },
        getCountry() {
            const city = this.organization.city;
            return city ? city.substring(city.indexOf("(") + 1, city.indexOf(")")) : "";
        },
        getVideo() {
            let video = this.organization.media.video || this.organization.video || "";   //"https://www.youtube.com/watch?v=7cSbjf5GVFg";
            let url = video;
            if (video.includes("youtube")) {
                url = `https://www.youtube.com/embed/${video.substring(video.indexOf("=") + 1, video.length)}?picture-in-picture=1&accelerometer=1&gyroscope=1`;
            }
            if (video.includes("vimeo")) {
                url = `https://player.vimeo.com/video/${video.substring(video.length - 9, video.length)}`;
            }
            if (!video.includes("http") && video !== "") {
                url = `http://${video}`;
            }
            return url;
        },
        isComplete() {
            return this.getVideo !== "" && this.organization.achievement && this.organization.achievement !== "" && this.organization.purpose && this.organization.purpose !== "";
        },
        isGenderCommitted() {
            // TODO: Manejar caso en que "No"
            const commitment = this.organization.gender.split(",");
            return commitment[0] === "Sí" ? true : false;
        },
        logoCover() {
            let path = "";
            if (this.organization.media.cover && this.organization.media.cover != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_COVER_PATH + (this.organization.cover || this.organization.media.cover);
            }
            return path;
        },
        logoPath() {
            let path = require("@/assets/images/avatar-default-icon.webp");
            if (this.organization && this.organization.media.logo && this.organization.media.logo != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + (this.organization.logo || this.organization.media.logo);
            }
            return path;
        },
        title() {
            return this.organization.name;
        }
    },

    methods: {
        onCloseClick() {
            this.dialog = false;
        },
        getBenefits(value) {
            const benefits = [
                { name: "Horario Flexible", src: require("@/assets/icons/ico-time.png") },
                { name: "Vestimenta Informal", src: require("@/assets/icons/ico-dress.png") },
                { name: "Computador", src: require("@/assets/icons/ico-computer.png") },
                { name: "Cobertura de salud", src: require("@/assets/icons/ico-health.png") },
                { name: "Ayuda con reubicación", src: require("@/assets/icons/ico-place.png") },
                { name: "Pre y Post natal Adicional a lo legal", src: require("@/assets/icons/ico-birth.png") },
                { name: "Vacaciones Extras", src: require("@/assets/icons/ico-vacations.png") },
            ];
            const myBenefit = benefits.find(item => item.name === value);
            return myBenefit.src;
        },
        getInnerText(html) {
            let temp = document.createElement("div");
            temp.innerHTML = html;
            return temp.textContent || temp.innerText || "";
        },
    },
};
</script>
